import BrandLicenses from "./BrandLicenses";

export default BrandLicenses;
